export interface User {
  id: number;
  username: string;
  email: string;
  full_name: string;
  phone?: string;
  nickname?: string;
  last_login?: string;
  created_at?: string;
}

export interface UserPreferences {
  id?: number;
  user_id?: number;
  dietary_restrictions: string[];
  dietary_notes?: string;
  accessibility_needs?: string;
  emergency_contact_name?: string;
  emergency_contact_phone?: string;
}

export const DIETARY_OPTIONS = [
  { value: 'vegetarian', label: 'Vegetarian' },
  { value: 'vegan', label: 'Vegan' },
  { value: 'gluten-free', label: 'Gluten-Free' },
  { value: 'dairy-free', label: 'Dairy-Free' },
  { value: 'nut-allergy', label: 'Nut Allergy' },
  { value: 'shellfish-allergy', label: 'Shellfish Allergy' },
  { value: 'halal', label: 'Halal' },
  { value: 'kosher', label: 'Kosher' },
  { value: 'other', label: 'Other' }
] as const;

export interface AuthTokens {
  accessToken: string;
  refreshToken: string;
}

export interface LoginCredentials {
  username: string;
  password: string;
}

export interface RegisterData {
  username: string;
  email: string;
  password: string;
  full_name: string;
}

export interface AuthResponse {
  message?: string;
  user: User;
  tokens?: AuthTokens;
}

export interface AuthError {
  error: string;
  message: string;
  details?: Array<{
    field: string;
    message: string;
  }>;
}
